import * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(/* webpackChunkName: "A2HS" */ './lazyIndex')
);

export { registerA2HSEventListeners } from './utils/a2hsEventListeners';
export { A2HSCampaignProvider } from './components/A2HSCampaignProvider';

export const LazyA2HSCustomBanner = createLazyComponent(lazyModule, m => m.A2HSCustomBanner);
export const LazyA2HSPersistentBanner = createLazyComponent(
    lazyModule,
    m => m.A2HSPersistentBanner
);
